import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CountrySelectionService } from '../../services/country-selection.service';
import { Country } from '../../interfaces/country';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
@Component({
  selector: 'app-country-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './country-selector.component.html',
  styleUrl: './country-selector.component.scss'
})
export class CountrySelectorComponent implements OnInit, OnDestroy {
  countries: Country[] = [];
  selectedIso: string | null = null;
  loading = true;
  private subscription: Subscription | null = null;

  constructor(
    private countrySelectionService: CountrySelectionService,
    private router: Router
  ) {}

  ngOnInit() {
    // Establecer el país seleccionado desde localStorage inmediatamente
    const currentIso = this.countrySelectionService.getSelectedCountryIso();
    if (currentIso) {
      this.selectedIso = currentIso;
    }
    
    // Suscribirse al observable de países
    this.subscription = this.countrySelectionService.countries$.subscribe(countries => {
      if (countries.length > 0) {
        this.countries = countries;
        this.loading = false;
        
        // Verificar si el país seleccionado existe en la lista
        if (this.selectedIso && !countries.some(c => c.isoCode === this.selectedIso)) {
          // Si no existe, eliminar el país seleccionado y redirigir a select-country
          this.countrySelectionService.clearSelectedCountry();
          this.router.navigate(['/select-country']);
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  changeCountry() {
    if (this.selectedIso) {
      this.countrySelectionService.setSelectedCountry(this.selectedIso);
      // Reload the page to apply the new country selection
      window.location.reload();
    }
  }
}
